export default {
  loggedIn: state => !!state.token,
  token: state => state.token
};
